import type { DiffResult } from '@tailorcast/shared-types';
import { DiffViewer } from '@features/approvals/components/DiffViewer';

interface TaskDiffsProps {
  diffs: DiffResult[];
}

export function TaskDiffs({ diffs }: TaskDiffsProps) {
  if (diffs.length === 0) {
    return <div className="text-sm text-gray-500">No changes made yet.</div>;
  }

  return (
    <div className="space-y-4">
      {diffs.map((diff) => (
        <div key={diff.stepId} className="card p-4">
          <div className="flex items-center justify-between mb-3">
            <div>
              <span className="text-sm font-medium text-gray-900">{diff.productTitle}</span>
              <span className="text-xs text-gray-500 ml-2">Step #{diff.stepNumber}</span>
            </div>
            <span className="text-xs text-gray-500">{diff.changeCount} changes</span>
          </div>
          <DiffViewer fieldDiffs={diff.fieldDiffs} />
        </div>
      ))}
    </div>
  );
}
